module.exports = __webpack_public_path__ + "static/media/hero-banner-@1x.446652a8.png";